import permission from "../../../http/requests/permission";

export default {
  fetchPermissions({ commit }, data) {
    return new Promise((resolve, reject) => {

      permission.fetch(data.email, data.token)
      .then((response) => {
        commit('SET_PERMISSIONS', response.data);

        resolve(response);
      })
      .catch((error) => { 
        reject(error);
      });
    });
  }
}